import ReactJson from "react-json-view";
import { Link } from "react-router-dom";
import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            <div className="h3 mb-3"></div>
            {/* <div className="h3 mb-3">Detail</div> */}
            <div className="row">
                {/* <ModalDetail title="primer_id" text={data?.primer_id} />
                <ModalDetail title="primer_name" text={data?.primer_name} />
                <ModalDetail title="purification" text={data?.purification} />
                <ModalDetail title="scale" text={data?.scale} />
                <ModalDetail title="sequence_5_to_3" text={data?.sequence_5_to_3} />
                <ModalDetail title="temp_c" text={data?.temp_c} />
                <ModalDetail title="amplification" text={data?.amplification} />
                <ModalDetail title="length" text={data?.length} />
                <ModalDetail title="ploymorphism" text={data?.ploymorphism} /> */}

                <div className="col-12">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>primer_id</th>
                                    <th>primer_name</th>
                                    <th>purification</th>
                                    <th>scale</th>
                                    <th>sequence_5_to_3</th>
                                    <th>temp_c</th>
                                    <th>amplification</th>
                                    <th>length</th>
                                    <th>ploymorphism</th>
                                    <th>rice_cultivar_th</th>
                                    <th>rice_cultivar_en</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{data?.primer_id}</td>
                                    <td>{data?.primer_name}</td>
                                    <td>{data?.purification}</td>
                                    <td>{data?.scale}</td>
                                    <td>{data?.sequence_5_to_3}</td>
                                    <td>{data?.temp_c}</td>
                                    <td>{data?.amplification}</td>
                                    <td>{data?.length}</td>
                                    <td>{data?.ploymorphism}</td>
                                    <td>{data?.rice_cultivar_th}</td>
                                    <td>{data?.rice_cultivar_en}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* <ModalDetail title="Image Name" text={data?.image} /> */}

                {data && data.image_url && (
                    <div className="col-12  mb-4">
                        {/* <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                            <div className="mx-2">
                                <FaRegDotCircle className="text-primary" />
                            </div>
                            <div>Image</div>
                        </div>
                        <div style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word" }}>
                            <a href={data?.image_url} target="_blank">
                                <img src={data?.image_url} alt={data?.image} style={{ width: "100%", cursor: "zoom-in" }} />
                            </a>
                        </div> */}
                        <a href={data?.image_url} target="_blank">
                            <img src={data?.image_url} alt={data?.image} style={{ width: "100%", cursor: "zoom-in" }} />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
